import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const AutoDebit = Loadable({
    loader: () => import('./AutoDebit'),
    render(loaded, props) {
      const Component = connect((state) => ({
        paymentAuthorizationAutoDebitState: state.paymentAuthorizationAutoDebitState,
        siteConfig: state.siteConfig
      }), {
        init,
        submit,
        languageChange
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/auto-debit`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AutoDebit {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
